module.exports = __webpack_public_path__ + "img/17-5-zh.6eaea7f6.jpg";